import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, message } from "antd";
import secureLocalStorage from "react-secure-storage";
import WeightagesService from "../../../Services/weightagesService.js";
import DataParser from "../../../utlits/Dataparser";
import { Helmet } from "react-helmet";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import TableSkeleton from "../../Reuseable/TableSkeleton";

message.config({ zIndex: 1000000001 });

const List = () => {
    const [list, setList] = useState([]);
    const [userPermissions, setUserPermissions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [itemToDelete, setItemToDelete] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        getData();
        setUserPermissions(DataParser.CompanyUserPermissions());
    }, []);

    const getData = () => {
        setIsLoading(true);
        WeightagesService.getWeightages(DataParser.CompanyId())
            .then((res) => {
                if (res.data === "Un-Athunticated request") {
                    secureLocalStorage.removeItem("adminInfo");
                    secureLocalStorage.removeItem("admins");
                    navigate("/");
                    return;
                }
                setList(res.data.weightages || []);
            })
            .catch(() => message.error("Failed to load list. Please try again!"))
            .finally(() => setIsLoading(false));
    };

    const handelPageChange = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
    };

    const handelDeleteItem = (e, item) => {
        e.preventDefault();
        setItemToDelete(item);
        document.getElementById("openDeleteWeightageModal").click();
    };

    const confirmDelete = async () => {
        if (!itemToDelete) return;
        setList((prev) => prev.filter((el) => el.id !== itemToDelete.id));
        document.getElementById("closeWeightageDeleteModal").click();
        try {
            const res = await WeightagesService.deleteWeightages(itemToDelete.id);
            if (res.data === "Un-Athunticated request") {
                secureLocalStorage.removeItem("adminInfo");
                secureLocalStorage.removeItem("admins");
                navigate("/");
                return;
            }
            message.success("Weightage deleted successfully!");
            getData();
        } catch {
            message.error("Failed to delete weightage. Please try again!");
            getData();
        }
        setItemToDelete(null);
    };

    const handelEditItem = (e, item) => {
        e.preventDefault();
        navigate(`/${DataParser.CompanyIdentifierRole()}/performanceweightage/${item.id}`, { state: { data: item } });
    };

    const PaginatedData = paginate(list, currentPage, pageSize);

    return (
        <>
            <Helmet>
                <title>Performance Weightage - Planit</title>
            </Helmet>
            <div className="main-content">
                <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 px-0">
                                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                                    <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                                        <ol className="breadcrumb mb-0">
                                            <li className="breadcrumb-item">
                                                <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                                            </li>
                                            <li className="breadcrumb-item active">
                                                <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                                            </li>
                                            <li className="breadcrumb-item active">Performance Weightage</li>
                                        </ol>
                                        {userPermissions.indexOf("weightages-create") !== -1 && list.length === 0 && (
                                            <Link
                                                to={`/${DataParser.CompanyIdentifierRole()}/performanceweightage/create`}
                                                className="btn btn-primary waves-effect waves-light"
                                            >
                                                Add Performance Weightage
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12 px-0">
                                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                                    <div className="card-body p-0">
                                        <div className="table-responsive listing-table-wrapper">
                                            <table className="table mb-0 custom-table listing-table">
                                                <thead>
                                                    <tr className="tableHeaderbg">
                                                        <th>Sr#</th>
                                                        <th>Attendance Weightage</th>
                                                        <th>Task Weightage</th>
                                                        <th>Task Process</th>
                                                        <th>Manager Review Weightage</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <TableSkeleton cols={6} rows={6} />
                                                    ) : PaginatedData.length > 0 ? (
                                                        PaginatedData.map((item, index) => (
                                                            <tr key={item.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.attendance}%</td>
                                                                <td>{item.task}%</td>
                                                                <td>{item.taskprocess}</td>
                                                                <td>{item.managerweightage}%</td>
                                                                <td>
                                                                    {userPermissions.indexOf("weightages-delete") !== -1 ? (
                                                                        <Link to="#" className="cursor-pointer iconscolor" onClick={(e) => handelDeleteItem(e, item)}>
                                                                            <Tooltip title="Delete">
                                                                                <i className="uil-trash iconscolor" />
                                                                            </Tooltip>
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="uil-trash iconscolor text-muted" style={{ cursor: "not-allowed", opacity: 0.5 }} />
                                                                    )}
                                                                    {userPermissions.indexOf("weightages-edit") !== -1 ? (
                                                                        <Link to="#" className="cursor-pointer iconscolor" onClick={(e) => handelEditItem(e, item)}>
                                                                            <Tooltip title="Edit">
                                                                                <i className="uil-pen iconscolor" />
                                                                            </Tooltip>
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="uil-pen iconscolor text-muted" style={{ cursor: "not-allowed", opacity: 0.5 }} />
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="6" className="text-center">
                                                                Add your first weightage by clicking the 'Add Performance Weightage' button.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>

                                            {list.length > pageSize && (
                                                <div className="d-flex justify-content-center mt-4">
                                                    <Pagination
                                                        itemCount={list.length}
                                                        currentPage={currentPage}
                                                        pageSize={pageSize}
                                                        onPageChange={handelPageChange}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Hidden trigger for delete modal */}
                <div id="openDeleteWeightageModal" data-bs-toggle="modal" data-bs-target="#deleteWeightageModal" style={{ display: "none" }} />

                {/* Delete Confirmation Modal */}
                <div id="deleteWeightageModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
                    <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
                        <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                            <div className="modal-header border-0 pb-1">
                                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Weightage</h5>
                                <button type="button" className="btn-close" id="closeWeightageDeleteModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
                            </div>
                            <div className="modal-body pt-2 pb-2">
                                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this weightage?</p>
                                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                                    <i className="uil uil-exclamation-triangle me-1" />
                                    This action cannot be undone.
                                </p>
                            </div>
                            <div className="modal-footer border-0 pt-1">
                                <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default List;
